import { Facebook, Instagram, Youtube } from "lucide-react";
import { IMAGES, SOCIALS } from "../data/site";
import Reveal from "./Reveal";

export const Social = () => (
  <section id="social" className="relative py-24 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <div className="max-w-2xl">
          <div className="mb-5 flex items-center gap-4">
            <span className="gold-rule" />
            <p className="text-[11px] font-bold uppercase tracking-[0.28em] text-gold-deep">
              Follow The Hunt
            </p>
          </div>
          <h2 className="font-serif text-3xl font-semibold tracking-tight text-navy sm:text-4xl lg:text-5xl">
            Site visits, reels &amp; <span className="text-gold-gradient italic">honest reviews.</span>
          </h2>
        </div>
      </Reveal>

      <div className="mt-12 grid gap-6 lg:grid-cols-2">
        <Reveal>
          <div
            data-testid="social-instagram-card"
            className="relative flex h-full min-h-[320px] flex-col justify-end overflow-hidden rounded-3xl border border-[#E7E3D8] p-8 sm:p-10"
          >
            <img
              src={IMAGES.coast}
              alt="Instagram — western suburbs property tours by Shivaay Consultant"
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-navy/95 via-navy/60 to-navy/10" />
            <div className="relative">
              <Instagram className="h-8 w-8 text-gold-light" />
              <h3 className="mt-4 font-serif text-3xl font-semibold text-white">@shivaayconsultant_</h3>
              <p className="mt-2 max-w-sm text-sm leading-relaxed text-white/80">
                Project tours, site-visit reels and handover stories from
                Borivali to Andheri — see the home before you visit.
              </p>
              <a
                href={SOCIALS.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="social-instagram-link"
                className="mt-6 inline-flex items-center gap-2 rounded-full bg-gold px-6 py-3 text-sm font-bold text-navy transition-all hover:bg-gold-light"
              >
                <Instagram className="h-4 w-4" />
                Follow on Instagram
              </a>
            </div>
          </div>
        </Reveal>

        <div className="grid gap-6 sm:grid-cols-2">
          <Reveal delay={0.1}>
            <a
              href={SOCIALS.facebook}
              target="_blank"
              rel="noreferrer"
              data-testid="social-facebook-link"
              className="flex h-full flex-col justify-between rounded-3xl border border-[#E7E3D8] bg-white p-8 transition-all hover:-translate-y-1 hover:border-gold-deep/50 hover:shadow-[0_18px_44px_rgba(14,32,56,0.1)]"
            >
              <Facebook className="h-7 w-7 text-[#4A90D9]" />
              <div className="mt-8">
                <h3 className="font-serif text-2xl font-semibold text-navy">Facebook</h3>
                <p className="mt-2 text-sm leading-relaxed text-navy/60">
                  Project updates, price trends and community events across the
                  western suburbs.
                </p>
              </div>
            </a>
          </Reveal>
          <Reveal delay={0.15}>
            <a
              href={SOCIALS.youtube}
              target="_blank"
              rel="noreferrer"
              data-testid="social-youtube-link"
              className="flex h-full flex-col justify-between rounded-3xl border border-[#E7E3D8] bg-white p-8 transition-all hover:-translate-y-1 hover:border-gold-deep/50 hover:shadow-[0_18px_44px_rgba(14,32,56,0.1)]"
            >
              <Youtube className="h-7 w-7 text-[#E40046]" />
              <div className="mt-8">
                <h3 className="font-serif text-2xl font-semibold text-navy">YouTube</h3>
                <p className="mt-2 text-sm leading-relaxed text-navy/60">
                  Full walkthrough films of projects and resale flats, East and
                  West.
                </p>
              </div>
            </a>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Social;
